export const FIRST_PAGE = 1

export const MAX_PAGES_TO_SHOW = 5

export const DEFAULT_PAGE_SIZE = 4
